/**
 * @generated SignedSource<<a63ac89adf0df82086cffbe492b68ee1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AvailabilityConfigInput = {
  practitionerId: string;
  duration: number;
};
export type userSetAvailabilityConfigMutation$variables = {
  input: AvailabilityConfigInput;
};
export type userSetAvailabilityConfigMutation$data = {
  readonly setAvailabilityConfig: boolean;
};
export type userSetAvailabilityConfigMutation = {
  variables: userSetAvailabilityConfigMutation$variables;
  response: userSetAvailabilityConfigMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "kind": "ScalarField",
    "name": "setAvailabilityConfig",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "userSetAvailabilityConfigMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "userSetAvailabilityConfigMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "4e8122d7d8970a8edf0fddf4e6c08d13",
    "id": null,
    "metadata": {},
    "name": "userSetAvailabilityConfigMutation",
    "operationKind": "mutation",
    "text": "mutation userSetAvailabilityConfigMutation(\n  $input: AvailabilityConfigInput!\n) {\n  setAvailabilityConfig(input: $input)\n}\n"
  }
};
})();

(node as any).hash = "93326a2d8e3b567dfd24982db8c4cd85";

export default node;
